export interface CreditCardFormFields {
  cardNumber: string;
  cardholderName: string;
  expirationDate: string;
  expirationMonth: string;
  expirationYear: string;
  securityCode: string;
  identificationType: string;
  identificationNumber: string;
  identificationNumberParsed: string;
  cardholderEmail: string;
  installments: string;
  issuer: string;
}

const errorsMap = {
  cc_rejected_bad_filled_card_number: ['cardNumber', 'invalid'],
  cc_rejected_bad_filled_date: ['expirationDate', 'invalid'],
  cc_rejected_bad_filled_security_code: ['securityCode', 'invalid'],
  cc_bad_parameter_card_required: ['cardNumber', 'empty'],
  cc_bad_parameter_invalid_email: ['cardholderEmail', 'invalid'],
} as const;

export function getCreditCardFormErrors(
  errorCode: string | undefined,
  errorsMercadoPago: Partial<CreditCardFormFields>,
  formErrors: Partial<CreditCardFormFields>,
): Partial<CreditCardFormFields> {
  let executionError: Partial<CreditCardFormFields> = {};
  if (errorCode && errorsMap[errorCode]) {
    const [key, errorType] = errorsMap[errorCode];
    executionError = { [key]: `form.${key}.errors.${errorType}` };
  }
  return { ...errorsMercadoPago, ...formErrors, ...executionError };
}
